<script>
import { Line } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  name: 'DailyUserChart',
  extends: Line,
  props: {
    chartData: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      required: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    drawChart() {
      if (!this.chartData || this.chartData.length < 1) return

      console.log(this.chartData)

      const labels = this.chartData.map(m => m.label)
      const signUps = this.chartData.map(m => m.signUps)
      const signIns = this.chartData.map(m => m.signIns)

      const maxYax = Math.max(...signUps, ...signIns)
      console.log('maxY:', maxYax)

      const brandSuccess = getStyle('--success') || '#4dbd74'
      const brandInfo = getStyle('--info') || '#20a8d8'

      this.renderChart({
        labels: labels,
        datasets: [
          {
            label: 'Sign Up',
            backgroundColor: hexToRgba(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: signUps
          },
          {
            label: 'Sign In',
            backgroundColor: 'transparent',
            borderColor: brandSuccess,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: signIns
          },
        ]
      }, {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(maxYax / 5),
              max: maxYax
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
        this.drawChart()
    })
  }
}
</script>
